import { Dayjs } from "dayjs";

export type TMaintenanceForm = {
  maintenanceMode: string;
  modeStartDateTime?: Dayjs | null;
  modeEndDateTime?: Dayjs | null;
  maintenanceMessage?: string | null;
};

export const maintenanceFormInitValues: TMaintenanceForm = {
  maintenanceMode: "",
  modeStartDateTime: null,
  modeEndDateTime: null,
  maintenanceMessage: null,
};
